import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"

function ucfirst(str) {
  var firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}

const POReportStatus = ({ control, name, onSelectChange }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [countriesData, setCountriesData] = useState([])

  const loadOptions = async () => {
    const data = [
      // { label: "Completed", value: 5 },
      // { label: "GRN received Bill not made", value: 1 },
      // { label: "GRN not received Bill not made", value: 2 },
      // { label: "Bill received GRN Not received", value: 3 },
      // { label: "Pending", value: 4 },
      { label: "Completed", value: 5 },
      { label: "Goods Received But Bill not made", value: 1 },
      { label: "PO Issued", value: 2 },
      { label: "Bill made But Goods not Received", value: 3 },
      { label: "Pending", value: 4 },
    ]
    setIsLoading(false)
    const countries = data.map(dta => {
      return {
        label: dta?.label && ucfirst(dta.label),
        value: dta.id,
        ...dta,
      }
    })

    setCountriesData(countries)
  }

  useEffect(() => {
    loadOptions()
  }, [])

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ref, value } }) => {
          return (
            <Select
              options={countriesData}
              placeholder={"Status"}
              isLoading={isLoading}
              inputRef={ref}
              onChange={e => {
                onChange(e)
                if (onSelectChange) onSelectChange(e)
              }}
              value={value}
              classNamePrefix="react-select"
              className="elevate-dropdown"
              menuPortalTarget={document.querySelector("body")}
            />
          )
        }}
      />
    </div>
  )
}

export default POReportStatus
